import Vue from "vue";
import SharedGenericLatestDetails from "./SharedGenericLatestDetails.vue";

export function load() {
  const selector = "shared-details-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SharedGenericLatestDetails, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
